import { createFileRoute } from "@tanstack/react-router";
import TreatmentNotWorkingHub from "@/pages/TreatmentNotWorkingHub";
export const Route = createFileRoute("/treatment-not-working")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "When Depression Treatment Fails | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What to do when antidepressants and therapy aren't working. Learn about treatment-resistant depression, TMS, SAINT®, SPRAVATO®, and your full range of options.",
        },
        {
          property: "og:title",
          content: "When Depression Treatment Fails | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What to do when antidepressants and therapy aren't working. Learn about treatment-resistant depression, TMS, SAINT®, SPRAVATO®, and your full range of options.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/depression-treatment-not-working",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/depression-treatment-not-working",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TreatmentNotWorkingHub />;
}
